<template>
  <div>
    <div>
      <ParallaxImages
        :heading="entry.textOverlay"
        :first-image-video="entry.image"
        :second-image-video="entry.videoFile"
        :third-image-video="entry.imageSecondary"
        :overlay-heading="entry.colorHeading"
        :overlay-text="entry.teaserText"
      />
    </div>
    <div class="AboutBlocksWrapper relative z-10 bg-white">
      <ContentBlocks :entry="entry" />
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag';
import ParallaxImages from '~/components/common/blocks/ParallaxImages';
import ContentBlocks from '@/components/common/ContentBlocks';
import { ContentBlocksMatrixFragment } from '@/components/common/ContentBlocksMatrixFragment.js';

export const AboutHomePageFragment = gql`
  fragment AboutHomePageFragment on aboutHome_Entry {
    textOverlay
    image {
      ...CraftAssetFragment
    }
    imageSecondary {
      ...CraftAssetFragment
    }
    videoFile {
      ...CraftAssetFragment
    }
    colorHeading
    teaserText
    contentBlocks {
      ...ContentBlocksMatrixFragment
    }
  }
  ${ContentBlocksMatrixFragment}
`;

export default defineNuxtComponent({
  name: 'AboutHomePage',
  components: {
    ParallaxImages,
    ContentBlocks,
  },
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
});
</script>
